import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {PerfilUsuario} from '../../../../interfaces/perfil-usuario.interface'
import { useEffect, useState } from 'react'
import { Pagination } from '../../../../components/Pagination'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import { actionsPerfil } from '../../../../actions/action-creators'
import { bindActionCreators } from 'redux'
import { userLoginSave } from '../../../../actions/userLogin.actions'

const MisSucursales = () => {
  const profileData: PerfilUsuario = useSelector((state: State) => state.gestionUsuario.perfilUsuario)
  const datosUsuario: any = useSelector((state: State) => state.userLogin.datos)

  const dispatch = useDispatch();
  const actions = bindActionCreators(actionsPerfil, dispatch)

  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [showConfirmChange, setShowConfirmChange] = useState<boolean>(false);
  const [sucursalSelect, setSucursalSelect] = useState(null);
  
  const openConfirmChange = (id_sucursal: number, sucursalObj: any) => {
    setSucursalSelect({id_sucursal, ...sucursalObj});
    setShowConfirmChange(true);
  }

  const handleChangeSucursal = async() => {
    await actions.changeSucursalSeleccionada(sucursalSelect);
    setShowConfirmChange(false);
  }

  useEffect(() => {
    profileData.sucursales?.forEach((sucursal) => {
      if (
        sucursal.sucursal_seleccionada && 
        sucursal.sucursal_idsucursal !== datosUsuario?.sucursal_seleccionada
      ) {
        // Actualizar sucursal seleccionada
        dispatch(userLoginSave({
          ...datosUsuario, 
          sucursal_seleccionada: sucursal.sucursal_idsucursal
        }))
      }
    })
  }, [profileData.sucursales])

  return (
    <>
      {
        showConfirmChange && 
        (
          <ModalConfirm Styles={{maxWidth: "500px"}}
            title={'Confirmar selección de sucursal'}
            detail={
              'Estás a punto de seleccionar esta sucursal para realizar operaciones, ¿Estás seguro que deseas continuar?'
            }
            messageAction='Sí'
            messageClose='No'
            actionConfirm={handleChangeSucursal}
            closeModalConfirm={() => setShowConfirmChange(false)}
          />
        )
      }
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
        <div className='card'>
          <div className='w-layout-vflex card-content'>
            <div>
              <h3 className='card-title l'>Sucursales</h3>
            </div>
            <div className='form-separator'></div>
            <table className='table-main-responsive responsive-table-main td-left'>
              <thead>
                <tr>
                  <td>Nombre de sucursal</td>
                  <td>Dirección</td>
                  <td>Descripción</td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {profileData.sucursales.length > 0 &&
                  currentItems.map(({Sucursal, sucursal_idsucursal, sucursal_seleccionada}: any, i: number) => (
                    <tr className='table-tr' key={i}>
                      <td data-label='Nombre de sucursal'>{Sucursal.nombre}</td>
                      <td data-label='Dirección'>{Sucursal.direccion}</td>
                      <td data-label='Descripción'>{Sucursal.descripcion}</td>
                      <td data-label='Acciones'>
                        {
                          (sucursal_seleccionada)
                          ?
                          (
                            <div className='state-sucursal sucursal-activa'>Sucursal activa</div>
                          )
                          :
                          (
                            <div onClick={() => openConfirmChange(sucursal_idsucursal, Sucursal)} className='state-sucursal sucursal-select'>Seleccionar sucursal</div>
                          )
                        }
                      </td>
                    </tr>
                ))}
              </tbody>
            </table>
            {profileData.sucursales.length > 0 && (
              <Pagination
                data={profileData.sucursales}
                state={(items: Array<any>) => setCurrentItems(items)}
                items={10}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default MisSucursales
